import { dayjs } from "~/lib/date-util";
import {
  MeQuestContentQuery,
  UserQuestProgressStatus,
} from "~/lib/graphql/client";

export function filterActiveQuest(
  p: MeQuestContentQuery["me"]["userQuestProgresses"][number]
) {
  const isOpen =
    dayjs(p.quest.startAt) <= dayjs() && dayjs() <= dayjs(p.quest.endAt);

  return p.status == UserQuestProgressStatus.Doing && isOpen;
}
